module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.37affc93712381589984.js");
};